import { Connection } from '../connection.class';
import { Vertex3 } from '../../../spatial-classes';

/**
 * takes the source connection for an island and moves the island based on the target, the directed alignments and padding
 * @param connection source connection
 * @returns boolean
 */
export const moveSourceIslandCfn = (connectionIn: Connection, visited: Set<string> = new Set<string>()): boolean => {
	// always use the source connection to move source island
	const connection = connectionIn.isSource ? connectionIn : connectionIn.targetConnection;
	if (!connection) return false;

	const { sourceIsland, targetIsland } = connection;
	if (targetIsland === null || sourceIsland === null) {
		console.warn('moveSourceIsland: Connection is not linked properly, run syncConnection once properly linked');
		return false;
	}

	// cycle guard: a looping or self-referential connection graph would otherwise recurse forever
	if (visited.has(sourceIsland.id)) return false;
	visited.add(sourceIsland.id);

	const sp = connection.getSourcePoint().rotateAxis(new Vertex3(), sourceIsland.axis.y, 'y');
	const tp = connection.getTargetPoint().rotateAxis(new Vertex3(), targetIsland.axis.y, 'y');

	const padding = new Vertex3({ dataIn: { z: connection.padding }});
	const paddingAngle = sourceIsland.axis.y - connection.sourcePanel.getOriginAngle();
	if (connection.sourcePanel)	padding.rotateAxis(new Vertex3(), paddingAngle, 'y');

	const offset = new Vertex3({ dataIn: { z: (connection.sourcePanel?.isLeftPanel ? 1 : -1) * (connection.offset) }})
	if (connection.sourcePanel)	offset.rotateAxis(new Vertex3(), sourceIsland.axis.y - connection.sourcePanel.getOriginAngle() + 90, 'y');

	// const delta = tpr.clone().subtract(sp);
	sourceIsland.origin
		.moveTo(targetIsland.origin)
		.add(tp)
		.subtract(sp)
		.subtract(padding)
		.subtract(offset);

	// recursively move all connections
	sourceIsland.connections.children.filter((c) => !c.isSource).forEach((c) => {
		moveSourceIslandCfn(c, visited);
	});

	// console.log('moveSourceIslandCfn', {
	// 	sourceBase: sourceIsland.position.origin.y + (sourceIsland.size.height / 2),
	// 	targetBase: targetIsland.position.origin.y + (targetIsland.size.height / 2)
	// });
	// console.log('!!!!', paddingDelta, { targetDelta, before: sourceIslandCenter, after: sourceIsland.position.centerpoint.serialize() });
	return true;
}
